export const APP_VERSION = '20261103-32c3de8';